import React, { useState, useEffect } from 'react';
import { Type } from 'lucide-react';

const STORAGE_KEY = 'tcube_font_scale';

const AccessibilityFab = () => {
  const [scale, setScale] = useState(1);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const saved = parseFloat(localStorage.getItem(STORAGE_KEY) || '1');
    setScale(saved);
    document.documentElement.style.fontSize = `${16 * saved}px`;
  }, []);

  const apply = (s) => {
    const clamped = Math.max(0.85, Math.min(1.3, s));
    setScale(clamped);
    localStorage.setItem(STORAGE_KEY, String(clamped));
    document.documentElement.style.fontSize = `${16 * clamped}px`;
  };

  return (
    <div className="fixed bottom-40 sm:bottom-24 right-4 sm:right-6 z-40" data-testid="a11y-tools">
      {open && (
        <div className="absolute bottom-14 right-0 bg-slate-900 border border-slate-700 rounded-2xl p-3 shadow-2xl w-44">
          <p className="text-slate-400 text-xs mb-2 px-1">Text Size</p>
          <div className="flex items-center justify-between gap-2">
            <button
              onClick={() => apply(scale - 0.1)}
              className="flex-1 bg-slate-800 hover:bg-slate-700 text-white text-sm py-1.5 rounded-lg"
              aria-label="Decrease text size"
              data-testid="font-decrease-btn"
            >A−</button>
            <button
              onClick={() => apply(1)}
              className="flex-1 bg-slate-800 hover:bg-slate-700 text-white text-xs py-1.5 rounded-lg"
              aria-label="Reset text size"
              data-testid="font-reset-btn"
            >Reset</button>
            <button
              onClick={() => apply(scale + 0.1)}
              className="flex-1 bg-slate-800 hover:bg-slate-700 text-white text-sm py-1.5 rounded-lg"
              aria-label="Increase text size"
              data-testid="font-increase-btn"
            >A+</button>
          </div>
          <p className="text-slate-500 text-[10px] mt-2 text-center">Scale: {(scale * 100).toFixed(0)}%</p>
        </div>
      )}
      <button
        onClick={() => setOpen(!open)}
        aria-label="Accessibility: adjust text size"
        aria-expanded={open}
        className="bg-slate-800 hover:bg-slate-700 border border-slate-700 text-slate-200 w-10 h-10 rounded-full shadow-lg flex items-center justify-center"
        data-testid="a11y-toggle-btn"
      >
        <Type className="w-4 h-4" aria-hidden="true" />
      </button>
    </div>
  );
};

export default AccessibilityFab;
